import React, { useEffect, useState, useRef } from "react";
import DataTable from 'react-data-table-component';

const FailedSalaries = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [invoices, setInvoices] = useState([]);
    const customStyles = {
        headCells: {
        style: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        },
    };
    const columns = [
        {
            name: 'S No',
            selector: (row) => row.id,
            width: "100px"
        },
        {
            name: 'Unique',
            selector: (row) => {
                return <span className="btn btn-warning">{row.bank_settlement_id}</span>
            },
            width: "100px"
        },
        {
            name: 'Tran. Ref',
            selector: (row) => row.transaction_reference,
            width: "200px"
        },
        {
            name: 'Ach Tran. Code',
            selector: (row) => row.ach_transaction_code,
            sortable: true,
        },
        {
            name: 'Bene. Name',
            selector: (row) => row.beneficiary_name,
            sortable: true,
            wrap: true
        },
        {
            name: 'User Name',
            selector: (row) => row.user_name,
            sortable: true,
            wrap: true
        },
        {
            name: 'Amount',
            selector: (row) => Number(row.amount_paise) / 100,
            sortable: true,
            wrap: true
        },
        {
            name: 'Destination IFSC',
            selector: (row) => row.destination_ifsc_micr_iin,
            sortable: true,
            wrap: true
        },
        {
            name: 'Beneficiary Account No',
            selector: (row) => row.beneficiary_account_no,
            sortable: true,
            wrap: true
        },
        {
            name: 'Sponsor IFSC',
            selector: (row) => row.sponsor_ifsc_micr_iin,
            sortable: true,
            wrap: true
        },
        {
            name: 'User Number',
            selector: (row) => row.user_number,
            sortable: true,
            wrap: true
        },
        {
            name: 'Product Type',
            selector: (row) => row.product_type,
            sortable: true,
            wrap: true
        },
        {
            name: 'Created At',
            selector: (row) => row.created_at,
            sortable: true,
            wrap: true,
        }
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };
    return (
        <DataTable
            customStyles={customStyles}
            className="dataTables_wrapper"
            columns={columns}
            data={invoices}
            fixedHeader
            fixedHeaderScrollHeight="600px"
            pagination
            paginationPerPage={10}
            paginationTotalRows={invoices.length}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onChangeRowsPerPage={handleChangeRowsPerPage}
        />
    )
}

export default FailedSalaries;